import { ENV_NAME, getEnvironment } from '@heidi/api/config';

export const reactStagingKinde = {
  clientId: '8ccf462380b34c8a8439965c7a7e6738',
  domain: 'https://heidihealth.kinde.com',
};

export const reactProductionKinde = {
  clientId: '7f410da91634463eacc2d0aff6791489',
  domain: 'https://heidi.kinde.com',
};

export const reactKindeConstants =
  getEnvironment() === ENV_NAME.PROD ? reactProductionKinde : reactStagingKinde;
